
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { isEmpty, isEqual } from "element-ui/src/utils/util";

import extendCascaderPannel from "@/components/pages/ProductCreate/extendCascaderPannel.vue";
const categroy = namespace("categroy");
@Component({ components: { extendCascaderPannel } })
export default class extendCascader extends Vue {
  @categroy.Action queryCategory;
  @Prop({ default: "" }) placeholder;
  @Prop({ default: true }) isInput;
  @Prop({ default: false }) disabled;
  @Prop({ default: true }) autoClosed;
  @Prop({ default: "/" }) splitString;
  @Prop({ type: Function }) lazyLoad;
  @Prop({ default: () => {} }) config;
  @Prop({ default: () => [] }) selectedValue;
  visible = false;
  selected: any = "";
  cascaderValue = [];

  @Watch("selectedValue", { immediate: true })
  watchSelectedValue(val) {
    if (!isEqual(val, this.cascaderValue)) {
      this.cascaderValue = this.selectedValue || [];
    }
    if (this.cascaderValue.length === 0) {
      this.selected = "";
    }
  }
  @Watch("visible", { immediate: true })
  watchVisible(val) {
    if (val) {
      this.tempText = "";
    }
    this.cascaderValue = this.selectedValue;
  }
  toggleTree() {
    this.visible = !this.visible;
  }
  get props() {
    let result = {
      lazy: true,
      lazyLoad: this.lazyLoad,
      children: "children",
      label: "label",
      value: "value",
      leaf: "isLeaf",
      ...this.config
    };

    return result;
  }
  async getPresentText() {
    let text = await (this.$refs.popCascader as any).getPresentText();
    return text;
  }
  tempText = "";
  async handleOk() {
    this.tempText = await this.getPresentText();

    this.$emit("selectConfirm", {
      value: this.cascaderValue,
      label: this.tempText
    });

    if (this.autoClosed) {
      this.selected = this.tempText;
      this.closePop();
    }
  }
  closePop() {
    (this.$refs.popExtendCascader as any).doClose();
  }
  async setPresentText() {
    this.selected = this.tempText;
    this.tempText = "";
  }
  emitDefaultText(text) {
    this.selected = text;
    this.$emit("emitDefaultText", text);
  }
}
